import React from 'react';
import './ManagerDashboardCardStyle.css';

function ManagerDashboardCard({ color1 = "#9575CD", color2 = '#A67DFF', title, count, icon, subTitle }) {
    return (
        <div className='manager_dc_container' style={{ background: `linear-gradient(to right, ${color1}, ${color2})` }}>
            <div className='manager_dc_layout'>
                <div className='manager_dc_top_section'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className='manager_dashboard_icon_style'>{icon}</span>
                        <span className='manager_dc_dot'>●</span>
                    </div>
                    <div className='manager_dashboard_icon_section'>
                        <span className='manager_dc_title_2'>{count}</span>
                    </div>
                </div>
                <div className='manager_dc_top_section'>
                    <span className='manager_dc_title_1'>{title}</span>
                    <span className='manager_dc_sub_title_2'>{subTitle}</span>
                </div>
            </div>
        </div>
    );
}

export default ManagerDashboardCard;
